import React, { useRef, useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import MicroModal from "micromodal";
import { Icon } from "@iconify/react";
import { FocusScope } from "react-aria";

import useObtenerSubsecciones from '../js/translations/useObtenerSubsecciones';
import postAjax from '../js/utilities/postAjax';
import getAjax from "../js/utilities/getAjax";
import getUrlParam from '../js/utilities/getUrl';
import { useQueryParams } from "../hooks/useQueryParams";

import { store, GENERAL_URL_API } from '../components/Store.js';
import ModalAlertas from '../components/ModalAlertas';

/**
 * Este componente se encarga de renderizar la caja del login cuando la sesión no esta activa. Su función principal es actualizar los datos de la sesión y redirigir el sitio a la pantalla adecuada. 
 * @param {object} visibility 
 * @returns CardLogin
 */
export const CardLogin = ({ visibility }) => {
  const { textosSubSecciones: textosLogin } = useObtenerSubsecciones('login');

  const globalState = useContext(store);
  const { dispatch, state } = globalState;

  const [messageLogin, setMessageLogin] = useState('');
  const [sendingLogin, setSendingLogin] = useState(false);
  const [message, setMessage] = useState('');
  const [description, setDescription] = useState('');

  const ref = useRef(null);
  const loginForm = useRef(null);
  const userName = useRef(null);
  const password = useRef(null);

  const history = useHistory();
  const params = useQueryParams();

  useEffect(() => {
    enviarUrl();
  }, [state?.sesionActiva])

  useEffect(() => {
    let ezproxy = '';
    if (typeof getUrlParam("ezproxy") !== "undefined") {
      ezproxy = decodeURIComponent(getUrlParam("ezproxy")).replace(/\+/g, " ");
      if (ezproxy !== '') {
        postAjax(`${GENERAL_URL_API}/assets/ezLogin`, { 'ip': ezproxy }, response => {
          if (response.includes('Exito')) {
            getAjax(`${GENERAL_URL_API}/assets/datosHeader`, {}, response => {
              let makemakeData = JSON.parse(response).makemakeData;
              let categoriasMenu = JSON.parse(response).categoriasMenu;
              window.localStorage.setItem('makemakeData', JSON.stringify(makemakeData))
              window.localStorage.setItem('categoriasMenu', JSON.stringify(categoriasMenu))
              dispatch({ type: 'CHANGE_VALUE', property: 'pais', value: makemakeData.pais })
              dispatch({ type: 'CHANGE_VALUE', property: 'sesionActiva', value: makemakeData.sesionActiva })
              dispatch({ type: 'CHANGE_VALUE', property: 'userType', value: makemakeData.userType })
              dispatch({ type: 'CHANGE_VALUE', property: 'username', value: makemakeData.username })
              dispatch({ type: 'CHANGE_VALUE', property: 'datosHeader', value: makemakeData.datosHeader })
              dispatch({ type: 'CHANGE_VALUE', property: 'categoriasMenu', value: categoriasMenu })
              dispatch({ type: 'CHANGE_VALUE', property: 'tipo', value: makemakeData.tipo })
              enviarUrl()
            })
          }

        })
      }
    }
  }, [])

  /**Cada vez que se monte este componente se activara el focus en el input usuario*/
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [])

  const close = () => {
    if (visibility?.set && typeof visibility.set === 'function') {
      visibility.set(false);
    }
  }

  const enviarUrl = () => {
    const bookUrl = params.get('bookT');
    if (state?.sesionActiva === 'SI') {
      if (params.has('bookT')) {
        history.push(bookUrl)
      } else {
        history.push('/')
      }
    }
  }

  const iniciarSesion = (e) => {
    if (loginForm.current.checkValidity()) {
      e.preventDefault();
      setSendingLogin(true);
      postAjax(`${GENERAL_URL_API}/assets/login`, { 'username': userName.current.value, 'password': password.current.value }, response => {
        if (response.includes('Exito')) {
          close();
          getAjax(`${GENERAL_URL_API}/assets/datosHeader`, {}, response => {
            let makemakeData = JSON.parse(response).makemakeData;
            let categoriasMenu = JSON.parse(response).categoriasMenu;
            window.localStorage.setItem('makemakeData', JSON.stringify(makemakeData))
            window.localStorage.setItem('categoriasMenu', JSON.stringify(categoriasMenu))
            dispatch({ type: 'CHANGE_VALUE', property: 'pais', value: makemakeData.pais })
            dispatch({ type: 'CHANGE_VALUE', property: 'sesionActiva', value: makemakeData.sesionActiva })
            dispatch({ type: 'CHANGE_VALUE', property: 'userType', value: makemakeData.userType })
            dispatch({ type: 'CHANGE_VALUE', property: 'username', value: makemakeData.username })
            dispatch({ type: 'CHANGE_VALUE', property: 'datosHeader', value: makemakeData.datosHeader })
            dispatch({ type: 'CHANGE_VALUE', property: 'categoriasMenu', value: categoriasMenu })
            dispatch({ type: 'CHANGE_VALUE', property: 'tipo', value: makemakeData?.tipo })
            setSendingLogin(false);
            enviarUrl()
          })
          //Esto recarga el sitio
          window.location.reload(true)
        } else {
          setSendingLogin(false);
          if (response.includes('Error, usuario o contraseña')) {
            setMessageLogin(textosLogin?.mensaje_alerta?.login || 'Has ingresado un nombre de usuario o contraseña incorrecto. Intenta otra vez.')
          } else if (response.includes('Error, concurrencias copadas')) {
            try {
              MicroModal.show('modal-alertas-autenticacion', {
                awaitCloseAnimation: true
              });
            }
            catch (error) {
              console.log('modal alertas error', error)
            }
            setMessage(textosLogin?.mensaje_alerta?.limite?.mensaje || 'Has superado el límite de concurrencias');
            setDescription(textosLogin?.mensaje_alerta?.limite?.descripcion || 'En este momento tienes más usuarios conectados de los que admite tu suscripción. Comunícate con ventas para aumentar la capacidad de usuarios simultáneos. Escríbenos a contacto@makemake.com.co');
          } else if (response.includes('Error, suscripcion caducada')) {
            try {
              MicroModal.show('modal-alertas-autenticacion', {
                awaitCloseAnimation: true
              });
            }
            catch (error) {
              console.log('modal alertas error', error)
            }

            setMessage(textosLogin?.mensaje_alerta?.caducado?.mensaje || 'Tu suscripción ha caducado');
            setDescription(textosLogin?.mensaje_alerta?.caducado?.descripcion || 'Comunícate con ventas para renovar el período de la suscripción o escríbenos a contacto@makemake.com.co');
          } else {
            console.error(response);
          }
        }

      })
    }
  }

  return (
    <FocusScope contain restoreFocus>
      <div
        onClick={(e) => e.target === e.currentTarget && close()}
        className={`wrapper-card-login ${visibility?.get ? 'visible' : 'hidden'}`}
        aria-hidden={visibility?.get ? false : true}
      >
        <button onClick={()=>close()}  aria-label="Botón cerrar inicios de sesión"></button>
        <div
          ref={ref}
          role="dialog"
          aria-labelledby="Panel inicios de sesión"
          className={`card-login scroll ${visibility?.get ? 'visible' : 'hidden'}`}
        >
          <div className="form-login p-4">
            <div className="d-flex d-lg-none justify-content-end">
              <button
                className="close-button"
                aria-label="Botón cerrar inicios de sesión"
                onClick={() => close()}>
                <Icon icon="fa:close" />
              </button>
            </div>

            <form
              ref={loginForm}
              id="loginctfId"
              name="loginctf"
              method="post"

            >
              <strong>
                {
                  (() => {
                    if (messageLogin !== '') {
                      return (
                        <p
                          className="text-center mb-3"
                          role={'alert'}
                          aria-live={'assertive'}
                        >
                          {messageLogin}
                        </p>
                      )
                    }
                  })()
                }
              </strong>

              {/* usuario */}
              <fieldset>
                <label htmlFor="inputUser" className="mb-2">
                  {textosLogin?.input_usuario?.usuario?.texto || 'Nombre de usuario'}
                </label>
                <input
                  ref={userName}
                  id="inputUser"
                  onClick={() => { setMessageLogin('') }}
                  autoComplete="username"
                  type="text"
                  className="form-control form-control-sm focusable-red mb-2"
                  placeholder={textosLogin?.input_usuario?.usuario?.placeholder || "Escribe tu nombre de usuario"}
                  name="user"
                  required
                />
              </fieldset>

              {/*contraseña  */}
              <fieldset>
                <label htmlFor="inputPassword" className="mb-2">
                  {textosLogin?.input_usuario?.contrasenia?.texto || 'Contraseña:'}
                </label>
                <input
                  ref={password}
                  autoComplete="off"
                  type="password"
                  className="form-control form-control-sm focusable-red mb-2"
                  id="inputPassword"
                  placeholder={textosLogin?.input_usuario?.contrasenia?.placeholder || "Escribe tu contraseña"}
                  name="password"
                  required
                />
              </fieldset>

              <div className="row mx-0 mt-3">
                <div className="col-sm-6 px-0 mb-3 mb-sm-0">
                  {/* <Link 
                    to='/' 
                    className="olvide-contrasena focusable-red"
                    onClick={()=>close()}
                  >
                    {textosLogin?.login?.botones?.olvide || 'Olvidé mi contraseña'}</Link> */}
                </div>
                <div className="col-sm-6 px-0 d-flex justify-content-end">
                  <button
                    onClick={(e) => iniciarSesion(e)}
                    className="btn-iniciar-sesion focusable-red"
                  >
                    {(() => {
                      if (sendingLogin) {
                        return (
                          <i className="fas fa-spinner fa-pulse"></i>
                        )
                      } else {
                        return textosLogin?.login?.botones?.iniciar_sesion || 'Iniciar sesión'
                      }
                    })()}
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="register-login p-4">
            <p className="mb-3">{textosLogin?.titulos?.no_tienes || '¿No tienes una cuenta?'}</p>
            <div className="row mx-0">
              <div className="col-sm-6 mb-3 mb-sm-0 px-0 pr-sm-3">
                <Link 
                  to='/tienda/individual'
                  className="btn-register focusable-red"
                  onClick={()=>close()}
                >
                  {textosLogin?.login?.botones?.planes || 'Planes'}
                </Link>
              </div>
              <div className="col-sm-6 px-0">
                <Link 
                  to='/codigo/redimir' 
                  className="btn-register focusable-red"
                  onClick={()=>close()}
                >
                  {textosLogin?.login?.botones?.redimir || 'Redimir un código'}
                </Link>
              </div>
            </div>
          </div>

          <div className="other-logins p-4">
            <p className="title-other">{textosLogin?.titulos?.otros_inicios || 'Otros inicios de sesión'}</p>

            <div className="row justify-content-center mx-0 pt-3 pb-5">
              <div className="col-6 col-sm-4 col-lg-6 px-0">
                <a href="https://planlector.makemake.com.co/login" className="otro-inicio img-plan colegios mx-auto d-block focusable-red">
                  <p className="text-center py-1 px-2">{textosLogin?.login?.botones?.colegios || 'Colegios'}</p>
                </a>
              </div>
              <div className="col-6 col-sm-4 col-lg-6 px-0">
                <a className="otro-inicio img-plan mx-auto academia d-block focusable-red" href="https://academia.makemake.com.co/login">
                  <p className="text-center py-1 px-2 ">{textosLogin?.login?.botones?.academia || 'Academia'}</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <ModalAlertas
          id={"modal-alertas-autenticacion"}
          message={message}
          description={description}
        />
      </div>
    </FocusScope>
  )
}